import type { Almacen, CajaConfig, EstanteConfig, PasilloConfig } from '../types'

export const LETRAS_ESTANTE = 'ABCDEFGH'.split('')

export function nombreCaja(indice: number): string {
  return `Caja ${String(indice).padStart(2, '0')}`
}

export function crearCajas(prefijo: string, cantidad: number, capacidad: number): CajaConfig[] {
  return Array.from({ length: cantidad }).map((_, i) => ({
    id: `${prefijo}-c${i + 1}`,
    nombre: nombreCaja(i + 1),
    capacidad,
  }))
}

export function crearEstantes(
  prefijo: string,
  cantidad: number,
  cajasPorEstante: number,
  capacidad: number,
): EstanteConfig[] {
  return Array.from({ length: cantidad }).map((_, i) => ({
    id: `${prefijo}-e${i + 1}`,
    nombre: `Estante ${LETRAS_ESTANTE[i] ?? i + 1}`,
    cajas: crearCajas(`${prefijo}-e${i + 1}`, cajasPorEstante, capacidad),
  }))
}

export function crearPasillos(
  prefijo: string,
  cantidad: number,
  estantesPorPasillo: number,
  cajasPorEstante: number,
  capacidad: number,
): PasilloConfig[] {
  return Array.from({ length: cantidad }).map((_, i) => ({
    id: `${prefijo}-p${i + 1}`,
    nombre: `Pasillo ${i + 1}`,
    estantes: crearEstantes(
      `${prefijo}-p${i + 1}`,
      estantesPorPasillo,
      cajasPorEstante,
      capacidad,
    ),
  }))
}

export function crearAlmacen(datos: {
  id: string
  sucursalId: string
  nombre: string
  descripcion: string
  pasillos: number
  estantesPorPasillo: number
  cajasPorEstante: number
  capacidad: number
}): Almacen {
  return {
    id: datos.id,
    sucursalId: datos.sucursalId,
    nombre: datos.nombre,
    descripcion: datos.descripcion,
    pasillos: crearPasillos(
      datos.id,
      datos.pasillos,
      datos.estantesPorPasillo,
      datos.cajasPorEstante,
      datos.capacidad,
    ),
  }
}

/** Estructura física de ejemplo. Editable desde Configuración → Sucursales y almacenes. */
export const ALMACENES_INICIALES: Almacen[] = [
  crearAlmacen({
    id: 'alm-ver-a',
    sucursalId: 'ver',
    nombre: 'Almacén A',
    descripcion: 'Planta baja, ala norte. Expedientes activos y en trámite.',
    pasillos: 3,
    estantesPorPasillo: 4,
    cajasPorEstante: 15,
    capacidad: 6,
  }),
  crearAlmacen({
    id: 'alm-ver-b',
    sucursalId: 'ver',
    nombre: 'Almacén B',
    descripcion: 'Bodega anexa. Expedientes concluidos y archivo histórico.',
    pasillos: 2,
    estantesPorPasillo: 3,
    cajasPorEstante: 10,
    capacidad: 8,
  }),
  crearAlmacen({
    id: 'alm-cmx-central',
    sucursalId: 'cmx',
    nombre: 'Almacén Central',
    descripcion: 'Piso 5, cuarto de archivo con control de acceso.',
    pasillos: 3,
    estantesPorPasillo: 4,
    cajasPorEstante: 15,
    capacidad: 6,
  }),
  crearAlmacen({
    id: 'alm-gdl-poniente',
    sucursalId: 'gdl',
    nombre: 'Almacén Poniente',
    descripcion: 'Bodega poniente, junto a recepción.',
    pasillos: 3,
    estantesPorPasillo: 4,
    cajasPorEstante: 15,
    capacidad: 6,
  }),
  crearAlmacen({
    id: 'alm-mty-norte',
    sucursalId: 'mty',
    nombre: 'Almacén Norte',
    descripcion: 'Sótano 1, archivo con estantería móvil.',
    pasillos: 3,
    estantesPorPasillo: 4,
    cajasPorEstante: 15,
    capacidad: 6,
  }),
]
